import {
  Button,
  Checkbox,
  ComboBox,
  Radio,
  Slider,
  TextInput,
} from '@components';
import { banks, currency } from '@utils';
import { Field, Formik } from 'formik';
import React, { useState } from 'react';
import { format, isBefore } from 'date-fns';
import { toast } from 'react-toastify';
import { ResgateParcialService } from '@services';
import {
  resgateParcialRegimeSchema,
  resgateParcialPercentuaisSchema,
  resgateParcialBancariosSchema,
} from '../../../../common/schemas/beneficios/resgate-parcial';
import { NotaExplicativa } from '../components/NotaExplicativa';
import { gerarDetalhamentoResgateParcialPDF } from '../utils/resgate-parcial';

export const StepsResgateSimulacao = ({
  setErroModalIsOpen,
  setMsgErro,
  setExibiSucesso,
  setViewTerms,
  dadosPrevidenciarios,
  dadosEmprestimo,
  dadosPessoais,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [termoAceite, setTermoAceite] = useState({
    termo01: false,
    termo02: false,
    termo03: false,
    termo04: false,
    termo05: false,
    termo06: false,
    termo07: false,
    termo08: false,
  });
  const [steps, setSteps] = useState({
    one: dadosPrevidenciarios.RegimeDefinitivo !== 'SIM',
    two: dadosPrevidenciarios.RegimeDefinitivo === 'SIM',
    three: false,
    four: false,
    five: false,
  });
  const [viewSteps, setViewSteps] = useState({
    one: true,
    two: dadosPrevidenciarios.RegimeDefinitivo === 'SIM',
    three: false,
    four: false,
    five: false,
  });
  const [registroParams, setRegistroParams] = useState({
    regimeTributacao:
      dadosPrevidenciarios.RegimeDefinitivo === 'SIM'
        ? dadosPrevidenciarios.RegimeTributacao
        : '',
  });
  const [infosDetails, setInfosDetails] = useState({});

  function registrarPedidoResgateParcial() {
    setIsLoading(true);
    const service = new ResgateParcialService();
    service
      .InserirDadosRegistroOpcaoResgate({
        matricula: dadosPessoais.matricula,
        plano: dadosPessoais.plano,
        autor: dadosPessoais.matricula,
        percentualResgatadoContaIndividual: registroParams.contaIndividual,
        percentualResgatadoContaAdicional: registroParams.contaAdicional,
        percentualResgatadoContaEventual: registroParams.contaEventual,
        percentualResgatadoContaPortabilidadeAberta:
          registroParams.contaPortabilidadeAberta,
        percentualResgatado: Number(infosDetails.percentualRetirado.toFixed(2)),
        percentualRemanescenteSaqueVista: Number(
          infosDetails.percentualRemanescenteSaqueVista.toFixed(2)
        ),
        ...registroParams,
      })
      .then((res) => {
        if (res.sucesso) {
          setExibiSucesso(true);
          toast.success(res.msg);
        } else {
          setMsgErro(res.msg);
          setErroModalIsOpen(true);
        }
      })
      .finnaly(() => {
        setIsLoading(false);
      });
  }

  function formatarResultadoResgate(result, params) {
    const aliquotaIndividual =
      registroParams.regimeTributacao === 'REGRESSIVO'
        ? result.AliquotaIndividualRegressiva
        : 15;
    const aliquotaAdicional =
      registroParams.regimeTributacao === 'REGRESSIVO'
        ? result.AliquotaAdicionalRegressiva
        : 15;
    const aliquotaEventual =
      registroParams.regimeTributacao === 'REGRESSIVO'
        ? result.AliquotaEventualRegressiva
        : 15;
    const aliquotaPortabilidadeAberta =
      registroParams.regimeTributacao === 'REGRESSIVO'
        ? result.AliquotaPortabilidadeAbertaRegressiva
        : 15;
    const aliquotaTotal =
      registroParams.regimeTributacao === 'REGRESSIVO'
        ? result.AliquotaValorTotalRegressivo
        : 15;

    const valorSemIR =
      result.ValorTotalResgate -
      (result.ValorTotalResgate * aliquotaTotal) / 100;

    // Empréstimo
    const descontoTotalEmprestimo = Math.min(
      valorSemIR,
      dadosEmprestimo.SaldoVencido +
        dadosEmprestimo.SaldoVencer * (result.percentualRetirado / 100) || 0
    );
    const saldoVencidoEmprestimo = Math.min(
      valorSemIR,
      dadosEmprestimo.SaldoVencido
    );

    const SaldoVencerEmprestimo = Math.min(
      valorSemIR - saldoVencidoEmprestimo,
      dadosEmprestimo.SaldoVencer * (result.percentualRetirado / 100)
    );

    setInfosDetails({
      percentualRetirado: result.percentualRetirado,
      percentualRemanescenteSaqueVista: result.percentualRestante,
      valorTotalIndividual:
        (result.ValorIndividual * (100 - aliquotaIndividual)) / 100,
      valorTotalAdicional:
        (result.ValorAdicional * (100 - aliquotaAdicional)) / 100,
      valorTotalEventual:
        (result.ValorEventual * (100 - aliquotaEventual)) / 100,
      valorTotalPortabilidadeAberta:
        (result.ValorPortabilidadeAberta *
          (100 - aliquotaPortabilidadeAberta)) /
        100,
      valorTotal: valorSemIR - descontoTotalEmprestimo,
      msgConsistencia:
        descontoTotalEmprestimo > valorSemIR
          ? 'O desconto de empréstimo é superior ao valor solicitado.'
          : '',
      contaIndividual: [
        {
          label: 'Percentual solicitado',
          value: `${params.contaIndividual}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(result.ValorIndividual),
        },
        {
          label: `Aliquota imposto ${registroParams.regimeTributacao}`,
          value: `${aliquotaIndividual}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(
            -((result.ValorIndividual * aliquotaIndividual) / 100)
          ),
        },
      ],
      contaAdicional: [
        {
          label: 'Percentual solicitado',
          value: `${params.contaAdicional}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(result.ValorAdicional),
        },
        {
          label: `Aliquota imposto ${registroParams.regimeTributacao}`,
          value: `${aliquotaAdicional}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(-((result.ValorAdicional * aliquotaAdicional) / 100)),
        },
      ],
      contaEventual: [
        {
          label: 'Percentual solicitado',
          value: `${params.contaEventual}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(result.ValorEventual),
        },
        {
          label: `Aliquota imposto ${registroParams.regimeTributacao}`,
          value: `${aliquotaEventual}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(-((result.ValorEventual * aliquotaEventual) / 100)),
        },
      ],
      contaPortabilidadeAberta: [
        {
          label: 'Percentual solicitado',
          value: `${params.contaPortabilidadeAberta}%`,
        },
        {
          label: 'Previsto para liberação',
          value: currency(result.ValorPortabilidadeAberta),
        },
        {
          label: `Aliquota imposto ${registroParams.regimeTributacao}`,
          value: `${aliquotaPortabilidadeAberta}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(
            -(
              (result.ValorPortabilidadeAberta * aliquotaPortabilidadeAberta) /
              100
            )
          ),
        },
      ],
      detalhamento: [
        {
          label: 'Valor solicitado',
          value: currency(result.ValorTotalResgate),
        },
        {
          label: `Aliquota imposto ${registroParams.regimeTributacao}`,
          value: `${aliquotaTotal}%`,
        },
        {
          label: 'Desconto imposto de renda',
          value: currency(-((result.ValorTotalResgate * aliquotaTotal) / 100)),
        },
        {
          label: 'Desconto empréstimo',
          value: currency(-descontoTotalEmprestimo),
          details: [
            {
              label: 'Valor vencido',
              value: currency(-saldoVencidoEmprestimo || 0),
            },
            {
              label: 'Proporção do saldo a vencer',
              value: currency(-SaldoVencerEmprestimo),
            },
          ],
        },
      ],
    });
  }

  function handleSteps(value) {
    const changedValues = {
      ...!steps,
      [value]: !steps[value],
    };

    const changedViewSteps = {
      ...viewSteps,
      [value]: true,
    };

    setSteps(changedValues);
    setViewSteps(changedViewSteps);
  }

  function handleSimulateValues(values) {
    const service = new ResgateParcialService();
    service
      .ObterDadosPrevidenciariosResgate(
        dadosPessoais.matricula,
        dadosPessoais.plano,
        values.contaIndividual,
        values.contaAdicional,
        values.contaEventual,
        values.contaPortabilidadeAberta
      )
      .then((res) => {
        const dataLimite = new Date(2018, 3, 30);
        const percentualMaximo =
          isBefore(new Date(dadosPrevidenciarios.DataInscricao), dataLimite) &&
          dadosPessoais.plano !== '2'
            ? 45
            : 30;

        const percentualRetirado =
          (res.ValorTotalResgate / res.ValorIntegral) * 100;

        const percentualRestante = percentualMaximo - percentualRetirado;

        const descontoEmprestimo =
          dadosEmprestimo.SaldoVencido +
            dadosEmprestimo.SaldoVencer * (percentualRetirado / 100) || 0;

        formatarResultadoResgate(
          {
            ...res,
            percentualRetirado,
            percentualRestante,
            descontoEmprestimo,
          },
          values
        );
        handleSteps('three');
      });
  }

  return (
    <>
      <div id="step-01" className={`tbstep ${!steps.one && 'tbhide'}`}>
        <div className="tbHeaderTitle">
          <span
            className={`tbstepNumber ${steps.one && 'tbstepNumber-focused'} ${
              viewSteps.one && !steps.one && 'tbstepNumber-filled'
            }`}
          >
            1
          </span>

          <div className="tbstepTitle">
            <h2>
              {dadosPrevidenciarios.RegimeDefinitivo === 'SIM' ? (
                <strong>
                  Regime de Tributação: {dadosPrevidenciarios.RegimeTributacao}
                </strong>
              ) : (
                <strong>Regime de Tributação</strong>
              )}
            </h2>
            {steps.one && <p>Escolha o Regime de Tributação.</p>}
          </div>
        </div>

        <div className="tbstepContent">
          {viewSteps.one &&
            !steps.one &&
            dadosPrevidenciarios.RegimeDefinitivo !== 'SIM' && (
              <button className="tbviewStep" onClick={() => handleSteps('one')}>
                Editar
              </button>
            )}

          {steps.one && (
            <Formik
              initialValues={{
                opcaoRegimeTributacao: registroParams.regimeTributacao,
              }}
              validationSchema={resgateParcialRegimeSchema}
              onSubmit={(values) => {
                setRegistroParams({
                  ...registroParams,
                  regimeTributacao: values.opcaoRegimeTributacao,
                });
                handleSteps('two');
              }}
            >
              {({ handleSubmit, isValid }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <div className="contentOption">
                      <div className="contentHeader">
                        <h3 className="content-headerTitle">
                          Qual opção deseja requerer?
                        </h3>
                      </div>
                      <p className="content-description">
                        O primeiro passo é escolher o Regime de Tributação do
                        Imposto de Renda, que será calculado em seu Resgate
                        Parcial. Esta escolha é obrigatória e não poderá ser
                        alterada após a conclusão do pedido de Resgate Parcial.
                      </p>
                      <div className="content-options">
                        <Field
                          name="opcaoRegimeTributacao"
                          value="PROGRESSIVO"
                          color="orange"
                          type="radio"
                          label="Progressivo: os valores recebidos da Forluz serão tributados conforme tabela para cálculo do Imposto de Renda, o que significa que o desconto do imposto na fonte terá alíquotas variáveis, conforme o montante recebido. Ou seja: quanto maior o valor, maior será a alíquota aplicada. Atualmente, esses percentuais variam de 0% a 27,5%. Além disso, neste regime, podem ocorrer deduções mensais (quando aplicável) e ajustes a serem feitos na Declaração Anual."
                          component={Radio}
                          className="ts-16"
                        />
                        <Field
                          name="opcaoRegimeTributacao"
                          value="REGRESSIVO"
                          color="orange"
                          type="radio"
                          label="Regressivo: neste caso, o IR pago no recebimento dos valores vai variar de 35% a 10%, segundo o tempo de aporte de recursos ao plano. Ou seja, quanto maior o tempo de acumulação, menor será o percentual aplicado. A tributação será exclusivamente na fonte. Sendo assim, não ocorrem deduções e nem são realizados ajustes posteriores na Declaração Anual."
                          component={Radio}
                          className="ts-16"
                        />
                      </div>
                    </div>

                    <div className="contentOption">
                      <div className="contentHeader">
                        <h3 className="content-headerTitle">Consentimento</h3>
                      </div>
                      <div className="content-options">
                        <div className="d-flex align-items-center gap-2">
                          <Checkbox
                            className="terms"
                            defaultChecked={termoAceite.termo01}
                            onChange={() =>
                              setTermoAceite({
                                ...termoAceite,
                                termo01: !termoAceite.termo01,
                              })
                            }
                          />
                          <p className="text-black ts-16">
                            Estou ciente que a opção escolhida é IRRETRATÁVEL e
                            DEFINITIVA, ou seja, saques posteriores, resgates e
                            o benefício futuro terão a tributação calculada
                            segundo o regime de tributação agora optado.
                          </p>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <Checkbox
                            className="terms"
                            defaultChecked={termoAceite.termo02}
                            onChange={() =>
                              setTermoAceite({
                                ...termoAceite,
                                termo02: !termoAceite.termo02,
                              })
                            }
                          />
                          <p className="text-black ts-16">
                            Estou ciente que, caso eu já tenha feito algum
                            resgate, será desconsiderada a opção marcada acima,
                            sendo aplicado o regime escolhido no primeiro
                            resgate.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="tbbutton gap-4">
                      <Button
                        transparent
                        color="orange"
                        className="max-100"
                        onClick={() => setViewTerms(true)}
                      >
                        Voltar
                      </Button>
                      <Button
                        className="max-100"
                        type="submit"
                        disabled={
                          !isValid ||
                          !termoAceite.termo01 ||
                          !termoAceite.termo02
                        }
                      >
                        Continuar
                      </Button>
                    </div>
                  </form>
                );
              }}
            </Formik>
          )}
        </div>
      </div>

      <div id="step-02" className={`tbstep ${!steps.two && 'tbhide'}`}>
        <div className="tbHeaderTitle">
          <span
            className={`tbstepNumber ${steps.two && 'tbstepNumber-focused'} ${
              viewSteps.two && !steps.two && 'tbstepNumber-filled'
            }`}
          >
            2
          </span>

          <div className="tbstepTitle">
            <h2>
              <strong>Escolha os valores</strong>
            </h2>
            {steps.two && <p>Escolha os percentuais que deseja resgatar</p>}
          </div>
        </div>

        <div className="tbstepContent">
          {viewSteps.two && !steps.two && (
            <button className="tbviewStep" onClick={() => handleSteps('two')}>
              Editar
            </button>
          )}

          {steps.two && (
            <>
              <div className="tbOptionLabel">
                <p>
                  Valores disponíveis em{' '}
                  {format(
                    new Date(dadosPrevidenciarios.DataReferencia),
                    'MM/yyyy'
                  )}
                </p>
              </div>

              <Formik
                initialValues={{
                  contaIndividual: registroParams.contaIndividual || 0,
                  contaAdicional: registroParams.contaAdicional || 0,
                  contaEventual: registroParams.contaEventual || 0,
                  contaPortabilidadeAberta:
                    registroParams.contaPortabilidadeAberta || 0,
                }}
                validationSchema={resgateParcialPercentuaisSchema}
                onSubmit={(values) => {
                  setRegistroParams({ ...registroParams, ...values });
                  handleSimulateValues(values);
                }}
              >
                {({ handleSubmit, isValid, values }) => {
                  return (
                    <form onSubmit={handleSubmit}>
                      <div className="contentOption">
                        <div className="contentHeader">
                          <h3 className="content-headerTitle">
                            Conta Individual
                          </h3>
                          <h3 className="content-headerTitle">
                            {currency(dadosPrevidenciarios.ValorIndividual)}
                          </h3>
                        </div>
                        <NotaExplicativa
                          aliquotaRegressiva={
                            dadosPrevidenciarios.AliquotaIndividual
                          }
                          percentualRetirada={20}
                          regimeTributacaoDefinitivo={
                            registroParams.regimeTributacao
                          }
                          conta="individual"
                        />
                        <Field
                          minValue={0}
                          maxValue={20}
                          name="contaIndividual"
                          component={Slider}
                          label="Qual percentual você deseja retirar?"
                        />
                        <ValorLiberacao
                          valor={
                            (dadosPrevidenciarios.ValorIndividual *
                              (values?.contaIndividual || 0)) /
                            100
                          }
                        />
                      </div>
                      {!!dadosPrevidenciarios.ValorAdicional && (
                        <div className="contentOption">
                          <div className="contentHeader">
                            <h3 className="content-headerTitle">
                              Conta Adicional
                            </h3>
                            <h3 className="content-headerTitle">
                              {currency(dadosPrevidenciarios.ValorAdicional)}
                            </h3>
                          </div>
                          <NotaExplicativa
                            aliquotaRegressiva={
                              dadosPrevidenciarios.AliquotaAdicional
                            }
                            percentualRetirada={100}
                            regimeTributacaoDefinitivo={
                              registroParams.regimeTributacao
                            }
                            conta="adicional"
                          />
                          <Field
                            minValue={0}
                            maxValue={100}
                            name="contaAdicional"
                            component={Slider}
                            label="Qual percentual você deseja retirar?"
                          />
                          <ValorLiberacao
                            valor={
                              (dadosPrevidenciarios.ValorAdicional *
                                (values?.contaAdicional || 0)) /
                              100
                            }
                          />
                        </div>
                      )}
                      {!!dadosPrevidenciarios.ValorEventual && (
                        <div className="contentOption">
                          <div className="contentHeader">
                            <h3 className="content-headerTitle">
                              Conta Eventual
                            </h3>
                            <h3 className="content-headerTitle">
                              {currency(dadosPrevidenciarios.ValorEventual)}
                            </h3>
                          </div>
                          <NotaExplicativa
                            aliquotaRegressiva={
                              dadosPrevidenciarios.AliquotaEventual
                            }
                            percentualRetirada={100}
                            regimeTributacaoDefinitivo={
                              registroParams.regimeTributacao
                            }
                            conta="eventual"
                          />
                          <Field
                            minValue={0}
                            maxValue={100}
                            name="contaEventual"
                            component={Slider}
                            label="Qual percentual você deseja retirar?"
                          />
                          <ValorLiberacao
                            valor={
                              (dadosPrevidenciarios.ValorEventual *
                                (values?.contaEventual || 0)) /
                              100
                            }
                          />
                        </div>
                      )}

                      {!!dadosPrevidenciarios.ValorPortabilidadeAberta && (
                        <div className="contentOption">
                          <div className="contentHeader">
                            <h3 className="content-headerTitle">
                              Conta Portabilidade Aberta
                            </h3>
                            <h3 className="content-headerTitle">
                              {currency(
                                dadosPrevidenciarios.ValorPortabilidadeAberta
                              )}
                            </h3>
                          </div>
                          <NotaExplicativa
                            aliquotaRegressiva={
                              dadosPrevidenciarios.AliquotaPortabilidadeAberta
                            }
                            percentualRetirada={100}
                            regimeTributacaoDefinitivo={
                              registroParams.regimeTributacao
                            }
                            conta="portabilidade aberta"
                          />
                          <Field
                            minValue={0}
                            maxValue={100}
                            name="contaPortabilidadeAberta"
                            component={Slider}
                            label="Qual percentual você deseja retirar?"
                          />
                          <ValorLiberacao
                            valor={
                              (dadosPrevidenciarios.ValorPortabilidadeAberta *
                                (values?.contaPortabilidadeAberta || 0)) /
                              100
                            }
                          />
                        </div>
                      )}

                      <div className="tbbutton gap-4">
                        <Button
                          transparent
                          color="orange"
                          className="max-100"
                          onClick={() => {
                            if (
                              dadosPrevidenciarios.RegimeDefinitivo !== 'SIM'
                            ) {
                              handleSteps('one');
                            } else {
                              setViewTerms(true);
                            }
                          }}
                        >
                          Voltar
                        </Button>
                        <Button
                          className="max-100"
                          disabled={!isValid}
                          onClick={handleSubmit}
                        >
                          Continuar
                        </Button>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </>
          )}
        </div>
      </div>

      <div id="step-03" className={`tbstep ${!steps.three && 'tbhide'}`}>
        <div className="tbHeaderTitle">
          <span
            className={`tbstepNumber ${steps.three && 'tbstepNumber-focused'} ${
              viewSteps.three && !steps.three && 'tbstepNumber-filled'
            }`}
          >
            3
          </span>

          <div className="tbstepTitle">
            <h2>
              <strong>Detalhamento do resgate</strong>
            </h2>
            {steps.three && (
              <p>
                Confira o detalhamento do resgate parcial que será solicitado
              </p>
            )}
          </div>
        </div>

        <div className="tbstepContent">
          {viewSteps.three && !steps.three && (
            <button className="tbviewStep" onClick={() => handleSteps('three')}>
              Visualizar
            </button>
          )}
          {steps.three && (
            <>
              <div className="result-container">
                <div className="result-title">
                  <p>Conta Individual</p>
                  <p>{currency(dadosPrevidenciarios.ValorIndividual)}</p>
                </div>
                <div className="tbrow" />
                {infosDetails.contaIndividual.map((item) => (
                  <div key={item.label} className="result-values">
                    <p>{item.label}</p>
                    <p>{item.value}</p>
                  </div>
                ))}
                <div className="tbrow" />
                <div className="result-values">
                  <p>Valor previsto para liberação</p>
                  <p className="result-total">
                    {currency(infosDetails.valorTotalIndividual)}
                  </p>
                </div>
              </div>
              {!!dadosPrevidenciarios.ValorAdicional && (
                <div className="result-container">
                  <div className="result-title">
                    <p>Conta Adicional</p>
                    <p>{currency(dadosPrevidenciarios.ValorAdicional)}</p>
                  </div>
                  <div className="tbrow" />
                  {infosDetails.contaAdicional.map((item) => (
                    <div key={item.label} className="result-values">
                      <p>{item.label}</p>
                      <p>{item.value}</p>
                    </div>
                  ))}
                  <div className="tbrow" />
                  <div className="result-values">
                    <p>Valor previsto para liberação</p>
                    <p className="result-total">
                      {currency(infosDetails.valorTotalAdicional)}
                    </p>
                  </div>
                </div>
              )}
              {!!dadosPrevidenciarios.ValorEventual && (
                <div className="result-container">
                  <div className="result-title">
                    <p>Conta Eventual</p>
                    <p>{currency(dadosPrevidenciarios.ValorEventual)}</p>
                  </div>
                  <div className="tbrow" />
                  {infosDetails.contaEventual.map((item) => (
                    <div key={item.label} className="result-values">
                      <p>{item.label}</p>
                      <p>{item.value}</p>
                    </div>
                  ))}
                  <div className="tbrow" />
                  <div className="result-values">
                    <p>Valor previsto para liberação</p>
                    <p className="result-total">
                      {currency(infosDetails.valorTotalEventual)}
                    </p>
                  </div>
                </div>
              )}
              {!!dadosPrevidenciarios.ValorPortabilidadeAberta && (
                <div className="result-container">
                  <div className="result-title">
                    <p>Conta Portabilidade Aberta</p>
                    <p>
                      {currency(dadosPrevidenciarios.ValorPortabilidadeAberta)}
                    </p>
                  </div>
                  <div className="tbrow" />
                  {infosDetails.contaPortabilidadeAberta.map((item) => (
                    <div key={item.label} className="result-values">
                      <p>{item.label}</p>
                      <p>{item.value}</p>
                    </div>
                  ))}
                  <div className="tbrow" />
                  <div className="result-values">
                    <p>Valor previsto para liberação</p>
                    <p className="result-total">
                      {currency(infosDetails.valorTotalPortabilidadeAberta)}
                    </p>
                  </div>
                </div>
              )}

              <div className="result-container">
                <div className="result-title">
                  <p>Detalhamento do resgate</p>
                </div>
                <div className="divider-orange" />
                {infosDetails.detalhamento.map((item) => (
                  <>
                    <div key={item.label} className="result-values">
                      <p>{item.label}</p>
                      <p>{item.value}</p>
                    </div>
                    {item.details &&
                      item.details.map((detail) => (
                        <div
                          key={detail.label}
                          className="result-values-details"
                        >
                          <p>{detail.label}</p>
                          <p>{detail.value}</p>
                        </div>
                      ))}
                  </>
                ))}
                <div className="tbrow" />
                <div className="result-values">
                  <p>Valor previsto para liberação</p>
                  <p className="result-total">
                    {currency(infosDetails.valorTotal)}
                  </p>
                </div>
                <span className="result-text-error">
                  {infosDetails.msgConsistencia}
                </span>
              </div>

              <div className="tbSimulationButtons">
                <Button
                  transparent
                  color="orange"
                  className="max-100"
                  onClick={() => {
                    setRegistroParams({
                      ...registroParams,
                      contaIndividual: 0,
                      contaAdicional: 0,
                      contaEventual: 0,
                      contaPortabilidadeAberta: 0,
                    });
                    handleSteps('two');
                  }}
                >
                  Alterar os valores
                </Button>

                <Button
                  className="max-100"
                  color="orange"
                  transparent
                  onClick={() =>
                    gerarDetalhamentoResgateParcialPDF(
                      dadosPessoais,
                      registroParams,
                      dadosEmprestimo,
                      dadosPrevidenciarios
                    )
                  }
                >
                  Imprimir detalhamento
                </Button>
              </div>
              <div className="tbSimulationButtons">
                <Button className="max-100" onClick={() => handleSteps('four')}>
                  Continuar
                </Button>
              </div>
            </>
          )}
        </div>
      </div>

      <div id="step-04" className={`tbstep ${!steps.four && 'tbhide'}`}>
        <div className="tbHeaderTitle">
          <span
            className={`tbstepNumber ${steps.four && 'tbstepNumber-focused'} ${
              viewSteps.four && !steps.four && 'tbstepNumber-filled'
            }`}
          >
            4
          </span>

          <div className="tbstepTitle">
            <h2>
              <strong>Dados bancários</strong>
            </h2>
            {steps.four && <> </>}
          </div>
        </div>

        <div className="tbstepContent">
          {viewSteps.four && !steps.four && (
            <button className="tbviewStep" onClick={() => handleSteps('four')}>
              Editar
            </button>
          )}

          {steps.four && (
            <>
              <div className="rp-bank-description">
                <h3>
                  Informe os dados bancários da conta que deseja receber o
                  resgate:
                </h3>
                <p>
                  A conta a ser informada precisa obrigatoriamente ser conta
                  corrente e pertencer ao titular do plano.
                </p>
              </div>
              <Formik
                initialValues={{
                  codigoBanco: registroParams.codigoBanco,
                  agencia: registroParams.agencia,
                  contaCorrente: registroParams.contaCorrente,
                  digito: registroParams.digito,
                  numeroParcelas: 1,
                }}
                validationSchema={resgateParcialBancariosSchema}
                onSubmit={(values) => {
                  setRegistroParams({
                    ...registroParams,
                    ...values,
                    contaCorrente: `${values.contaCorrente}-${values.digito}`,
                  });
                  handleSteps('five');
                }}
              >
                {({ handleSubmit, isValid, values }) => (
                  <form onSubmit={handleSubmit}>
                    <div>
                      <Field
                        name="codigoBanco"
                        className="mb-3"
                        component={ComboBox}
                        label="Qual é o seu banco?"
                        options={banks.map((s) => {
                          return {
                            value: s.codigo,
                            label: `${s.codigo} - ${s.banco}`,
                          };
                        })}
                      />
                    </div>
                    <div className="rp-bank-wrapper">
                      <div className="rp-bank-flex">
                        <Field
                          type="text"
                          name="agencia"
                          noPadding
                          component={TextInput}
                          label="Agência"
                        />
                      </div>
                      <div className="rp-bank-flex">
                        <Field
                          name="contaCorrente"
                          type="text"
                          component={TextInput}
                          label="Nº da Conta Corrente"
                        />
                      </div>
                      <div className="rp-bank-dv">
                        <Field
                          name="digito"
                          type="text"
                          noPadding
                          component={TextInput}
                          label="Digito"
                        />
                      </div>
                    </div>
                    {/* <div className="rp-bank-description">
                      <h3>Como deseja receber o resgate parcial?</h3>
                      <Field
                        name="numeroParcelas"
                        type="number"
                        className="mb-3"
                        disabled
                        component={TextInput}
                        label="Escolha o número de parcelas"
                      />
                    </div> */}
                    <div className="rp-btn">
                      <Button
                        transparent
                        color="orange"
                        className="max-100"
                        onClick={() => handleSteps('three')}
                      >
                        Voltar
                      </Button>
                      <Button
                        disabled={!isValid || values.codigoBanco === ''}
                        className="max-100"
                        type="submit"
                        onClick={handleSubmit}
                      >
                        Continuar
                      </Button>
                    </div>
                  </form>
                )}
              </Formik>
            </>
          )}
        </div>
      </div>

      <div id="step-05" className={`tbstep ${!steps.five && 'tbhide'}`}>
        <div className="tbHeaderTitle">
          <span
            className={`tbstepNumber ${steps.five && 'tbstepNumber-focused'} ${
              viewSteps.five && !steps.five && 'tbstepNumber-filled'
            }`}
          >
            5
          </span>

          <div className="tbstepTitle">
            <h2>
              <strong>Efetivação</strong>
            </h2>
            {steps.five && (
              <p>Leia atentamente sobre os consentimentos necessários.</p>
            )}
          </div>
        </div>

        <div className="tbstepContent">
          {viewSteps.five && !steps.five && (
            <button className="tbviewStep" onClick={() => handleSteps('five')}>
              Editar
            </button>
          )}

          {steps.five && (
            <>
              <div className="contentOption">
                <div className="contentHeader">
                  <h3 className="content-headerTitle">Consentimento</h3>
                </div>
                <div className="content-options">
                  <div className="d-flex align-items-center gap-2">
                    <Checkbox
                      className="terms"
                      defaultChecked={termoAceite.termo03}
                      onChange={() =>
                        setTermoAceite({
                          ...termoAceite,
                          termo03: !termoAceite.termo03,
                        })
                      }
                    />
                    <p className="text-black ts-16">
                      Estou ciente que o valor solicitado corresponde a{' '}
                      <b>{infosDetails.percentualRetirado?.toFixed(2)}%</b> do
                      meu saldo de conta e será abatido do percentual disponível
                      para retirada de parcela à vista no ato do requerimento de
                      benefício mensal.
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Checkbox
                      className="terms"
                      defaultChecked={termoAceite.termo04}
                      onChange={() =>
                        setTermoAceite({
                          ...termoAceite,
                          termo04: !termoAceite.termo04,
                        })
                      }
                    />
                    <div>
                      <p className="text-black ts-16 mb-2">
                        Estou ciente que os valores escolhidos para o Resgate
                        Parcial podem sofrer alterações devido à atualização do
                        saldo de contas. No momento do pagamento, será
                        considerado o percentual do Resgate Parcial por mim
                        escolhido.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Checkbox
                      className="terms"
                      defaultChecked={termoAceite.termo05}
                      onChange={() =>
                        setTermoAceite({
                          ...termoAceite,
                          termo05: !termoAceite.termo05,
                        })
                      }
                    />
                    <div>
                      <p className="text-black ts-16 mb-2">
                        Estou ciente que, para o valor líquido a ser creditado,
                        além da variação da rentabilidade, será aplicado o
                        desconto do imposto de renda, que implica uma escolha
                        irreversível e irretratável, tendo impacto no valor
                        final dos benefícios futuros. E ainda, para os
                        participantes com contrato de empréstimo em vigor, o
                        saldo devedor vencido será abatido e o saldo devedor a
                        vencer será proporcionalmente amortizado no Resgate
                        Parcial.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Checkbox
                      className="terms"
                      defaultChecked={termoAceite.termo06}
                      onChange={() =>
                        setTermoAceite({
                          ...termoAceite,
                          termo06: !termoAceite.termo06,
                        })
                      }
                    />
                    <div>
                      <p className="text-black ts-16 mb-2">
                        Estou ciente que os valores referentes ao saldo devedor
                        de empréstimo informado, quando houver, estão
                        posicionados em{' '}
                        {format(
                          new Date(dadosEmprestimo.DataReferencia),
                          'MM/yyyy'
                        )}{' '}
                        e serão atualizados no momento do pagamento, podendo,
                        portanto, sofrer alteração.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Checkbox
                      className="terms"
                      defaultChecked={termoAceite.termo07}
                      onChange={() =>
                        setTermoAceite({
                          ...termoAceite,
                          termo07: !termoAceite.termo07,
                        })
                      }
                    />
                    <div>
                      <p className="text-black ts-16 mb-2">
                        Estou ciente que o depósito do Resgate Parcial é
                        programado para ocorrer no último dia útil do mês
                        posterior a esta solicitação. Porém, conforme previsto
                        em Regulamento, a Forluz tem o prazo de até 60
                        (sessenta) dias após a data da formalização do pedido
                        para efetivar o crédito.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <Checkbox
                      className="terms"
                      defaultChecked={termoAceite.termo08}
                      onChange={() =>
                        setTermoAceite({
                          ...termoAceite,
                          termo08: !termoAceite.termo08,
                        })
                      }
                    />
                    <div>
                      <p className="text-black ts-16 mb-2">
                        Estou ciente que os dados bancários informados para
                        crédito de Resgate Parcial também serão utilizados para
                        futuro crédito de empréstimo, se contratado, e possíveis
                        débitos em conta de parcelas de empréstimo.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tbbutton gap-4">
                <Button
                  transparent
                  color="orange"
                  className="max-100"
                  onClick={() => handleSteps('four')}
                >
                  Voltar
                </Button>
                <Button
                  className="max-100"
                  disabled={
                    !termoAceite.termo03 ||
                    !termoAceite.termo04 ||
                    !termoAceite.termo05 ||
                    !termoAceite.termo06 ||
                    !termoAceite.termo07 ||
                    !termoAceite.termo08 ||
                    isLoading
                  }
                  onClick={() => registrarPedidoResgateParcial()}
                >
                  Solicitar resgate parcial
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const ValorLiberacao = ({ valor }) => {
  return (
    <div className="valorLiberacao-container">
      <p className="valorLiberacao-value">{currency(valor)}</p>
      <p className="valorLiberacao-span">valor previsto para liberação</p>
    </div>
  );
};
